import * as React from 'react';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import MainStore from '@src/pages/main/store';
import Page from '@src/layout-components/page';
import $$tracker from '@src/tracker';
import { GAME_OFFICIAL_WEBSITE } from '@src/constants/urls';

const styles = require('./index.less');
const kvVideo = require('./images/kv.mp4');
const downloadIcon = require('./images/downloadicon.png');

const pageLinks = [
  ['#/page1', '铁浮城战 焕新重启', '铁浮城战'],
  ['#/page2', '天王觉醒 再耀锋芒', '天王觉醒'],
  ['#/page3', '珍材现世 打宝赚金', '珍材现世'],
  ['#/page4', '十八周年 盛馈江湖', '十八周年'],
  ['#/page5', '周年特献 首个生态服', '周年特献']
];

const Main = () => {
  useStore(() => new MainStore());
  // Keep the shared footer adjacent to the fixed-ratio KV on tall viewports.
  React.useLayoutEffect(() => {
    const root = document.getElementById('root');
    const main = document.getElementById('main');
    root.classList.add('main-page-root');
    main.classList.add('main-page-main');

    return () => {
      root.classList.remove('main-page-root');
      main.classList.remove('main-page-main');
    };
  }, []);

  return (
    <Page className={styles.root}>
      <main className={styles.kv}>
        <a
          className={styles.officialLogo}
          href={GAME_OFFICIAL_WEBSITE}
          aria-label="剑侠世界官网"
          onClick={() => $$tracker.clickGoWebsite()}
          target="_blank"
          rel="noopener noreferrer"
        >
          剑侠世界官网
        </a>
        <video src={kvVideo} autoPlay loop muted playsInline webkit-playsinline="true" x5-playsinline="true" x5-video-player-fullscreen="true" />
        <a
          className={styles.download}
          href="//jxsj.xoyo.com/index/download.html"
          target="_blank"
          rel="noopener noreferrer"
          title="下载游戏"
          onClick={() => $$tracker.clickDownload()}
        >
          <img src={downloadIcon} alt="下载游戏" />
        </a>
        <nav className={styles.kvNav} aria-label="资料片内容">
          <ul>
            {pageLinks.map(([href, label, trackerTitle]) => (
              <li key={href}>
                <a href={href} onClick={() => $$tracker.clickHomeMenu(trackerTitle)}>
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </nav>
      </main>
    </Page>
  );
};

export default observer(Main);
